import { htmlNew, htmlOnInput, htmlTagged } from '../fun-js-lib/html'
import { mechanizationHint, nWorkersHint } from './hint'

export function initValidateWorkers () {
  getWorkersEditableInputs().forEach(input => {
    htmlOnInput(input, validate)
  })
  htmlOnInput(getMechanizationTextarea(), validate)
  validate()
}

function validate () {
  let isHintSet = validateWorkers()
  isHintSet = validateMechanization(isHintSet)
  if (!isHintSet) {
    unsetErrorHint()
  }
}

function validateWorkers () {
  getWorkersEditableInputs().forEach(input => {
    let valid = isNWorkersValidOrEmpty(input.value)
    input.classList.toggle('is-invalid', !valid)
  })
  let invalid = isNWorkerssFilledIncorrectly()
  if (invalid) {
    setErrorHint(nWorkersHint)
  }
  return invalid
}

/**
 * @param {boolean} wasHintSet 
 */
function validateMechanization (wasHintSet) {
  let textarea = getMechanizationTextarea()
  let isHintSet = !isMechanizationValidOrEmpty(textarea.value)
  textarea.classList.toggle('is-invalid', isHintSet)
  if (!wasHintSet && isHintSet) {
    setErrorHint(mechanizationHint)
  }
  return wasHintSet || isHintSet
}

/**
 * Returns true iff some of number of workers fields are filled
 * but incorrect
 */
export const isNWorkerssFilledIncorrectly = () =>
  getWorkersEditableInputs().some(input =>
    !isNWorkersValidOrEmpty(input.value))

/**
 * Returns true iff mechanization field is filled
 * but incorrect
 */
export const isMechanizationFilledIncorrectly = () =>
  !isMechanizationValidOrEmpty(getMechanizationTextarea().value)

/**
 * @param {string} value 
 */
const isNWorkersValidOrEmpty = value =>
  isValidNWorkers(value) || value === ''

/**
 * @param {string} value 
 */
const isMechanizationValidOrEmpty = value =>
  isValidMechanization(value) || value === ''

/**
 * @param {string} str 
 */
export function isValidNWorkers (str) {
  return /^\d{1,3}$/.test(str)
}

/**
 * @param {string} str 
 */
function isValidMechanization (str) {
  return str.length <= 450
}

export function getWorkersEditableInputs () {
  return htmlTagged(container(), 'input')
    .filter(input => !(
      input.hasAttribute('disabled') ||
      input.hasAttribute('readonly')
    ))
}

export function getMechanizationTextarea () {
  return htmlTagged(container(), 'textarea')[0]
}

/**
 * @param {string} hint 
 */
function setErrorHint (hint) {
  unsetErrorHint()
  let h5 = htmlNew('h5')
  h5.classList.add('text-center')
  let small = htmlNew('small')
  small.classList.add('text-danger')
  small.innerHTML = hint
  h5.appendChild(small)
  container()
    .prepend(h5)
}

function unsetErrorHint () {
  htmlTagged(container(), 'h5')
    .forEach(small => small.remove())
}

function container () {
  return document.getElementById('workersNumberContainer')
}